import React from "react";
import { Form, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FetchPendingList,
  updatestatus,
  FetchFilterInfo,
  getFilteredList,
  fetchNextRoundData,
} from "../../services/pendingService";
import Select from "react-select";
import { UpdateDetails } from "../../services/commonService";
import { useEffect, useRef, useState } from "react";
import api from "../../api";
import Dropdown from "react-bootstrap/Dropdown";
import ConfirmationModal from "./ConfirmationModal";
import UpdationModal from "./UpdationModal";
import UploadModal from "./UploadModal";
import { toast } from "react-toastify";
import action2 from "../../assets/images/brands/on-hold.svg";
import action3 from "../../assets/images/brands/Rejected.svg";
import SelectedSVG from "../../assets/images/brands/Selected.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { CSVLink } from "react-csv";
import { Modal, Button } from "react-bootstrap";
import { getCandidateNotes, getRemarks,getCityListAPI } from "helpers/backend_helper";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import mail_csv from "../../assets/images/icon/mail-csv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import cross from "../../assets/images/icon/cross.svg";
import job from "../../assets/images/icon/job-port.svg";
import education from "../../assets/images/icon/education-role.svg";
import star_exp from "../../assets/images/icon/exp_job.svg";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import name_icon from "../../assets/images/icon/name01.svg";
import user_icons1 from "../../assets/images/icon/user-ico7.svg";
import pending_icon from "../../assets/images/brands/Pending.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import addnotoes from "../../assets/images/icon/addnotoes.svg";

import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
  getDeviceInfo,
  formatDate,
  generateMaskedPII,
  useDebounce,
  getSubdomain
} from "helpers/utils";
import DatePicker from "react-datepicker";
import { utils } from "react-modern-calendar-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Spinner } from "reactstrap";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SearchData from "./SearchData";
import { decryptDataFromArray } from "helpers/EncDec";
import TimeslotBookingAdmin from "./../Screening_Test/TimeslotBookingAdmin";
import ButtonLoader from "components/Common/ButtonLoader";
import { Trans, useTranslation } from "react-i18next";
import RemotePagination from "components/Common/RemotePagination";
import SearchBar from "components/Common/Searchbar";

function PendingList(props) {
  const getDashboardFilterData = key => {
    let payloadObj = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    if (!key || !payloadObj?.filterValue) {
      return;
    }
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    return dashboardFilters?.[key] || "";
  };
  const subdomain = localStorage.getItem("subdomain") || "";
  const { t } = useTranslation();
  const [pendingData, setPendingData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showUpdationModal, setShowUpdationModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedApplId, setSelectedApplId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDOB, setSelectedDOB] = useState(null);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const [roleTypes, setRoleTypes] = useState([]);
  const [selectedRoleOptions, setSelectedRoleOptions] = useState([]);
  const [gender, setGender] = useState("");
  const [sourceType, setSourceType] = useState([]);
  const [tags, setTags] = useState([]);
  const [newtags, setnewTags] = useState("");
  const [source, setSource] = useState("");
  const [states, setStates] = useState([]);
  const [state, setState] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState(
    getDashboardFilterData("startDate")
      ? new Date(getDashboardFilterData("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    getDashboardFilterData("endDate")
      ? new Date(getDashboardFilterData("endDate"))
      : ""
  );
  const [type, setType] = useState(getDashboardFilterData("type") || "");
  const [query, setQuery] = useState("");
  const [errors, setErrors] = useState({});
  const userInfo = getUserInfo();
  const teamsIntegrated = userInfo?.teams_integration || false;
  const zoomIntegrated = userInfo?.zoom_integration || false;
  const [timezonelist, setTimezoneList] = useState([]);
  const [selectedTimezon, setSelectedTimezone] = useState("IST");
  const [int_start_time, setStartTime] = useState("");
  const [int_end_time, setEndTime] = useState("");
  const history = useHistory();

  // Interview Schedules timeslots initilization
  const [isTimeslotBtnDisabled, setIsTimeslotBtnDisabled] = useState(true);
  const [showTimeslotBooking, setShowTimeslotBooking] = useState(false);
  const [timeSlotsData, settimeSlotsData] = useState({});
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [sDateTimeSlots, setsDateTimeSlots] = useState([]);
  const [eDateTimeSlots, seteDateTimeSlots] = useState([]);
  const [daytimeSlots, setDaytimeSlots] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [bookedTimeSlots, setbookedTimeSlots] = useState([]);
  const [ErrorsTimeslots, setErrorsTimeslots] = useState({}); // State to track validation errors

  const [totalCounts, setTotalCounts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [allNotes, setAllNotes] = useState([]);
  const [readMoreStates, setReadMoreStates] = useState({});
  const [actionType, setActionType] = useState("reject");
  // 'reject' | 'shortlist'

  // Day to integer map
  const dayToIntegerMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const [csvData, setCSVData] = useState([]);

  //  Start Assessment
  const [assessmentModal, setAssessmentModal] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [interViewers, setinterViewers] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState({
    name: "",
    roleType: "",
    user_id: "",
    appl_id: "",
    vacancy_id: "",
    candidate_photo: "",
  });
  const [slotValues, setSlotValues] = useState([
    { label: "09:00 AM - 10:00 AM", value: "09:00 AM - 10:00 AM" },
    { label: "11:00 AM - 12:00 PM", value: "11:00 AM - 12:00 PM" },
    { label: "01:00 PM - 02:00 PM", value: "01:00 PM - 02:00 PM" },
    { label: "02:00 PM - 03:00 PM", value: "02:00 PM - 03:00 PM" },
    { label: "03:00 PM - 04:00 PM", value: "03:00 PM - 04:00 PM" },
    { label: "04:00 PM - 05:00 PM", value: "04:00 PM - 05:00 PM" },
    { label: "05:00 PM - 06:00 PM", value: "05:00 PM - 06:00 PM" },
  ]);



    const [filters, setFilters] = useState({});
      console.log(filters,"filterss")
  const [formData, setFormData] = useState({
    int_schedule_date: "",
    int_schedule_time: slotValues[0]?.value,
    interview_title: "",
    interviewer_time: interViewers?.[0]?.value,
    address: "",
    req_documents: "",
    meeting_type: 0,
    teams_interview: false,
    zoom_interview: false,
  });
  const [loading, setLoading] = useState(false);
  const [roundListData, setRoundListData] = useState([]);

  const STATUS_MAP = {
    reject: { code: 5, label: "Rejected" },
    shortlist: { code: 1, label: "In Progress" },
    selectcandidate: { code: 3, label: "Selected" },
    hold: { code: 4, label: "Onhold" },
  };
  const [isHold, setIsHold] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [isComment, setIsComment] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({});
  const [remarks, setRemarks] = useState([]);
  const [selectedRemark, setSelectedRemark] = useState(null);
    const [cityOptions, setCityOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const handleSearchCity = async text => {
    setSearchText(text);

    if (text.length < 2) return; // avoid unnecessary API calls

    try {
      const res = await getCityListAPI(text);

      if (res?.status) {
        setCityOptions(res.data.cities || []);
      }
    } catch (err) {
      console.error(err);
    }
  };



  useEffect(() => {
    if (isReject && actionType === "reject") {
      fetchRemarks();
    } else {
      // reset when switching action
      setRemarks([]);
      setSelectedRemark(null);
      setComment("");
      setCommentError("");
    }
  }, [isReject, actionType]);

  const handleRemarkChange = e => {
    const remarkId = e.target.value;
    const remark = remarks.find(r => r.id == remarkId);

    setSelectedRemark(remark);

    // Optional: auto-fill comment
    // setComment(remark?.remark_label || "");
  };

  const fetchRemarks = async () => {
    try {
      const res = await getRemarks("reject");
      console.log(res.data, "Remarks");
      setRemarks(res.data); // or res.data.data (check API)
    } catch (err) {
      console.error(err);
    }
  };

  const handleToggleForm = () => {
    setIsFormVisible(prev => !prev);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};
    // Validate int_schedule_date
    if (!int_start_time) {
      newErrors.int_start_time = t(`all-application.Field required`);
      valid = false;
    }

    // Validate int_schedule_time
    if (!int_end_time) {
      newErrors.int_end_time = t(`all-application.Field required`);
      valid = false;
    }
    // Validate starttime
    if (!selectedStartTime) {
      newErrors.selectedStartTime = t(`all-application.Field required`);
      valid = false;
    }

    // Validate end
    if (!selectedEndTime) {
      newErrors.selectedEndTime = t(`all-application.Field required`);
      valid = false;
    }

    // Create DateTime strings by combining the date and time
    const startDateTime = new Date(
      `${int_start_time.split("T")[0]}T${selectedStartTime}`
    );
    const endDateTime = new Date(
      `${int_end_time.split("T")[0]}T${selectedEndTime}`
    );
    // if (Date.parse(int_start_time) === Date.parse(int_end_time)) {
    //   newErrors.int_end_time =
    //     "End Date & Time and Start Date & Time cannot be the same.";
    //   valid = false;
    // }

    if (Date.parse(startDateTime) - Date.parse(new Date()) < 0) {
      newErrors.startDateTime = t(`all-application.Timeslot err 1`);
      valid = false;
    }
    if (Date.parse(endDateTime) - Date.parse(startDateTime) < 0) {
      newErrors.int_end_time = t(`all-application.Timeslot err 2`);
      valid = false;
    }

    // Check if start date + time is the same as end date + time
    if (startDateTime.getTime() === endDateTime.getTime()) {
      newErrors.int_end_time = t(`all-application.Timeslot err 3`);
      valid = false;
    }

    // Calculate the difference in milliseconds
    const timeDiffMs =
      new Date(endDateTime).getTime() - new Date(startDateTime).getTime();

    // Convert milliseconds to hours
    const timeDiffHours = timeDiffMs / (1000 * 60 * 60); // milliseconds to hours

    // Check if the difference exceeds 3 hours
    if (timeDiffHours > 3) {
      newErrors.int_end_time = t(`all-application.Timeslot err 4`);
      valid = false;
    }

    // Validate interview_title
    if (!formData.interview_title) {
      newErrors.interview_title = t(`all-application.Err 1`);
      valid = false;
    }

    // Validate interviewer_time
    if (!formData.interviewer_time) {
      newErrors.interviewer_time = t(`all-application.Err 2`);
      valid = false;
    }

    // Validate address
    if (!formData.address && formData.meeting_type === 0) {
      newErrors.address = t(`all-application.Err 3`);
      valid = false;
    }
    if (
      !formData.address &&
      formData.meeting_type === 1 &&
      !formData?.teams_interview
    ) {
      newErrors.address = t(`all-application.Err 4`);
      valid = false;
    }

    // Validate req_documents
    // if (!formData.req_documents) {
    //   newErrors.req_documents = "Valid Documents are required";
    //   valid = false;
    // }
    // console.log("newErrors", newErrors);
    setErrors(newErrors);
    return valid;
  };

  const getTimeZones = () => {
    let storeTimezone = [];
    userInfo?.timeZones?.map(item => {
      if (item) {
        storeTimezone.push({
          value: item?.alias,
          label:
            item?.alias +
            " (" +
            item?.location +
            ")" +
            " (GMT " +
            item?.offset +
            ")",
          offset: item?.offset,
          id: item?.id,
        });
      }
    });
    setTimezoneList(storeTimezone);
  };

  const handleInterviewModal = (roundId, roundType, roundName,interviewerId,meetingType) => {
    setIsFormVisible(prev => !prev)
    console.log(interviewerId,"interviewerId")
    setFormData({
      ...formData,
      roundId: roundId,
      roundType: roundType,
      interview_title: roundName,
      interviewer_time:interviewerId,
      meeting_type:meetingType || 0,
    });
  };

  const changeHandlers = e => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
    setErrors({
      ...errors,
      [e.target.name]: "",
    });

    // Conditionally call clearDtTime for specific fields
    if (name === "interviewer_time") {
      clearDtTime();
      setIsTimeslotBtnDisabled(true); // Disable Add TimeSlots button
      setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
    } else {
      // Enable the button if interviewer_time is valid
      const interviewerID = formData?.interviewer_time || 0;
      setIsTimeslotBtnDisabled(interviewerID <= 0);
    }
  };

  const fetchinterViewers = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/user/fetch-user`, {
      })
      .then(response => {
        let { userList, success } = decryptDataFromArray(response?.data);
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setinterViewers(data);
      })
      .catch(err => console.log("Error:::", err));
  };

  const convertDateFormat = dateString => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const handleInterviewSubmit = async e => {
    e.preventDefault(); // Prevent the default form submission behavior
    setLoading(true);
    const isValid = validateForm();

    if (!isValid) {
      setLoading(false);
      return;
    }

    const startDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_start_time)
    ).format("YYYY-MM-DD")}T${selectedStartTime}`;
    const endDateTimeString = `${moment(
      getCompanyTimezoneDateTime(int_end_time)
    ).format("YYYY-MM-DD")}T${selectedEndTime}`;

    let ChangedEventDate = moment(
      getCompanyTimezoneDateTime(startDateTimeString)
    ).utc();
    let ChangedEndEventDate = moment(
      getCompanyTimezoneDateTime(endDateTimeString)
    ).utc();

    const dynamicApplId = selectedApplId;
    const user_id = selectedCandidate?.user_id || "";
    let newFormData = JSON.parse(JSON.stringify(formData));
    const formattedDate = convertDateFormat(ChangedEventDate);
    newFormData.int_schedule_date = formattedDate;
    newFormData.int_start_time = ChangedEventDate;
    newFormData.int_end_time = ChangedEndEventDate;
    newFormData.time_zone_id = userInfo?.companyTimeZone?.id || null;
    let device_info = await getDeviceInfo(navigator);
    newFormData = {
      ...newFormData,
      device_info: device_info,
      old_status: "New Applications",
      new_status: "Assessment Center",
    };
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/screening/schedule-interview/${dynamicApplId}/${user_id}`,
        newFormData
      );
      toast.success(t(`all-application.Interview Scheduled`));
      getPendingList();
      handleToggleForm();
      setAssessmentModal(false);
      clearDtTime();
    } catch (error) {
      setAssessmentModal(false);
      toast.error(t(`all-application.Error submitting form`));
    } finally {
      setLoading(false);
    }
  };

  const handleCSVDownload = async e => {
    e.preventDefault();
    try {
      let csvData = [];
      if (isFiltered) {
        let payload = {
          type: "pending",
          gender: gender,
          role: selectedRoleOptions,
          source: source,
          state: state,
          city: city,
          area: area,
          startDate: startDate,
          endDate: endDate,
          newtags: newtags,
          pageSize: sizePerPage,
          page: currentPage,
          isCsvDownload: true,
        };
        csvData = await getFilteredList(payload);
      } else {
        csvData = await FetchPendingList({
          page: currentPage,
          queryText: query,
          pageSize: sizePerPage,
          isCsvDownload: true,
        });
      }

      if (csvData.data.status) {
        csvData = csvData?.data?.data?.map(item => ({
          ...item,
          email_id: generateMaskedPII(item?.email_id),
          mobile: generateMaskedPII(item?.mobile, 2),
        }));
        setCSVData(csvData);
        setTimeout(() => {
          let element = document.getElementById("downloadCSV");
          element.click();
        }, 1000);
        toast.success("File downloaded successfully.");
        setLoading(false);
      } else {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      }
    } catch (err) {
      return [];
    }
  };

  function calculateDaysAgo(applyDate) {
    const applyDateObj = new Date(applyDate);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - applyDateObj;

    // Convert milliseconds to days (1000 ms in a second, 60 seconds in a minute, 60 minutes in an hour, 24 hours in a day)
    const daysAgo = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return daysAgo;
  }

  const getPendingList = async (current = 1, size = 10, query_text = "", sort_field = sortField, sort_order = sortOrder) => {
    setLoading(true);
    await FetchPendingList({
      page: current,
      queryText: query_text,
      pageSize: size,
      ...(sort_field && { sortField: sort_field, sortOrder: sort_order }),
    })
      .then(res => {
        if (res.data.status) {
          // console.log(JSON.stringify(res.data.data), "res.data.data");
          setPendingData(res.data.data);
          setTotalCounts(res.data.total_counts);
          setLoading(false);
        } else {
          toast.error(t(`all-application.No data Available`));
          setLoading(false);
        }
      })
      .catch(err => {
        toast.error(t(`all-application.No data Available`));
        setLoading(false);
      });
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          setCities(filterData?.cities || []);
          setAreas(filterData?.areas || []);
          setRoleTypes(filterData?.roles || []);
          setSourceType(filterData?.sources || []);
          setStates(filterData?.states || []);
          setTags(filterData?.tagList || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  //Assesment center APIS calls
  const handleNotes = () => setShowNotes(!showNotes);
  const handleCloseModal = () => setShowNotes(!showNotes);
  const toggleReadMore = id => {
    setReadMoreStates(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const fetchCandidateNotes = async () => {
    if (!selectedCandidate?.appl_id) {
      return;
    }
    await getCandidateNotes(selectedApplId || selectedCandidate?.appl_id)
      .then(res => {
        setAllNotes(res?.data || []);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          t(`View Details.Something went wrong`);
        toast.error(errMsg);
      });
  };

  useEffect(() => {
    getTimeZones();
    if (type) {
      handleSubmit();
    } else {
      getPendingList();
    }
    getFilterInfo();
    fetchinterViewers();
    document.title = "NeuroTal - Pending Applications";
  }, []);

  useEffect(() => {
    fetchCandidateNotes();
  }, [selectedApplId, selectedCandidate?.appl_id]);

  const handleStartDateChange = date => handleDateChange(date, "start");
  const handleEndDateChange = date => handleDateChange(date, "end");

  const handleAssessmentStart = async (
    vacancy_id,
    user_id,
    appl_id,
    name,
    roleType,
    allInfo,
    created_time
  ) => {
    setAssessmentModal(true);
    setLoading(true);
    setSelectedApplId(appl_id);
    setSelectedCandidate({
      name: name,
      roleType: roleType,
      user_id: user_id,
      vacancy_id: vacancy_id,
      appl_id: appl_id,
      allInfo: allInfo,
      createdAt: created_time,
      candidate_photo: allInfo?.job_user?.candidate_photo,
    });
    let payload = {
      appl_id: appl_id,
      vacancy_id: vacancy_id,
      user_id: user_id,
    };
    await fetchNextRoundData(payload)
      .then(res => {
        if (res?.data?.success) {
          setLoading(false);
          setRoundListData(res?.data?.data || []);
        } else {
          setLoading(false);
          toast.error(t(`all-application.No data Available`));
        }
      })
      .catch(err => console.log(err));
  };

  const handleCloseAssessmentModal = () => {
    setAssessmentModal(!assessmentModal);
    setIsModalOpen(!isModalOpen);
  };

  const handleScreenTest = async (
    round_id,
    appl_id,
    user_id,
    vacancy_id,
    status
  ) => {
    try {
      const confirmed = window.confirm(
        t(`all-application.Send link confirmation`)
      );

      if (!confirmed) {
        return;
      }
      let authUser = JSON.parse(localStorage.getItem("authUser"));
      let adminId = authUser.user.id;
      let device_info = await getDeviceInfo(navigator);
      let response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/pending/update-screening`,
        {
          device_info: device_info,
          round_id,
          appl_id,
          user_id,
          vacancy_id,
          status,
          old_status: "New Applications",
          new_status: "Assessment Center",
          adminId,
        },
        {
        }
      );

      if (response.status === 200) {
        toast.success(t(`all-application.Send link successful`));
        getPendingList(); // Assuming getPendingList() is defined and fetches the updated list
      } else {
        toast.error(t(`all-application.Send link fail`));
      }
      handleCloseAssessmentModal();
    } catch (error) {
      console.log(error);
      toast.error("Error: " + error.message);
    }
  };

  const openModal = (message, appl_id, status) => {
    setShowModal(true);
    setModalMessage(message);
    setSelectedApplId(appl_id);
    setSelectedStatus(status);
  };
  const closeModal = () => {
    setShowModal(false);
    setModalMessage("");
    setSelectedApplId(null);
    setSelectedStatus(null);
  };

  const openUpdationModal = (message, user_id, dob, appl) => {
    setShowUpdationModal(true);
    setModalMessage(message);
    setSelectedApplId(appl?.appl_id);
    setSelectedUserID(user_id);
    setSelectedDOB(dob);
    setSelectedStatus(null);
  };

  const closeUpdationModal = () => {
    setShowUpdationModal(false);
    setModalMessage("");
    setSelectedApplId(null);
    setSelectedUserID(null);
    setSelectedDOB(null);
    setSelectedStatus(null);
  };
  const openUploadModal = (message, user_id) => {
    closeModal();
    setShowUploadModal(true);
    setModalMessage(message);
    setSelectedUserID(user_id);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setModalMessage("");
    setSelectedUserID(null);
  };

  const handleConfirm = async (
    appl_id,
    status,
    comment,
    new_status = "New Applications",
    remark_id = null
  ) => {
    if (isLoading) return;
    if (validateComment()) {
      let otherDetails = {};
      if (new_status) {
        otherDetails = {
          old_status: "New Applications",
          new_status: `${new_status} Applications`,
        };
      }
      console.log(status, "status");

      setIsLoading(true);
      await updatestatus(appl_id, status, comment, 0, remark_id, otherDetails)
        .then(res => {
          if (res.status === 200) {
            if (status === 5) {
              toast.success(t(`all-application.Record Rejected`));
            } else if (status === 4) {
              toast.success(t(`all-application.Record Onhold`));
            } else {
              toast.success(t(`all-application.Comment Added`));
            }
            getPendingList();
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          // console.log(error);
          toast.error(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
      comment_close();
      hold_close();
      reject_close();
    } else {
      // console.log("Validation error:", commentError);
    }
    // window.location.reload();
  };

  const handleUpdation = (user_id, dob, amValues) => {
    let formData = new FormData();
    formData.append("dob", dob);

    UpdateDetails(user_id, formData)
      .then(res => {
        if (res.status === 200) {
          toast.success(t(`all-application.Details Edited`));
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch(error => {
        // console.log(error);
      });
    closeUpdationModal();
  };

  const handleUpload = user_id => {
    openUploadModal("Upload Resume", user_id);
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allUsers = pendingData?.map(el => {
      if (el?.appl_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setPendingData(allUsers);
  };

  const handleStateChange = e => {
    setCity("");
    setState(e.target.value);
    let cityList = cities?.filter(
      el => el?.state_id === parseInt(e.target.value)
    );
    setFilteredCities(cityList);
  };

const handleSubmit = (newState, defaultType) => {
  if (!newState) {
    setCurrentPage(1);
    setSizePerPage(10);
  }

  const currentType = defaultType || type;

  let payload = {
    type: "pending",
    queryText: query,
    gender,
    role: selectedRoleOptions,
    source,
    state,
    city,
    area,
    preferred_city: filters?.preferred_location || [],
    newtags,
    pageSize: 10,
    page: 1,
  };

  if (currentType === "current") {
    const start = moment().startOf("month");
    const end = moment().endOf("month");

    payload.startDate = start.toISOString();
    payload.endDate = end.toISOString();

    setStartDate(start.toDate());
    setEndDate(end.toDate());

  } 
else if (type === "previous") {
          const start = moment().subtract(3, "months").toDate();
          const end = new Date();
          payload.startDate = moment(start).toISOString();
          payload.endDate = moment(end).toISOString();
          setStartDate(start);
          setEndDate(end);
        }

  const effectiveSortField = newState?.sortField !== undefined ? newState.sortField : sortField;
  const effectiveSortOrder = newState?.sortOrder !== undefined ? newState.sortOrder : sortOrder;

  const finalPayload = {
    ...(newState || {}),
    ...payload,
    ...(effectiveSortField && { sortField: effectiveSortField, sortOrder: effectiveSortOrder }),
  };

  // console.log("FINAL PAYLOAD 👉", finalPayload);

  getFilteredList(finalPayload)
    .then(res => {
      if (res.data.status) {
        setPendingData(res.data.data);
        setTotalCounts(res.data.total_counts);
        setIsFiltered(true);
      } else {
        toast.error(t(`all-application.No data Available`));
      }
      close();
    })
    .catch(err => console.log(err));
};

  const handleActionSubmit = () => {
    if (!STATUS_MAP[actionType]) {
      console.error("Invalid action type:", actionType);
      return;
    }

    const trimmedComment = comment.trim();

    if (actionType === "reject") {
      if (!selectedRemark) {
        setCommentError("Please select rejection reason");
        return;
      }

      if (selectedRemark.is_comment_required && !trimmedComment) {
        setCommentError("Comment is required");
        return;
      }
    }

    if (actionType !== "reject" && isCommentRequired && !trimmedComment) {
      setCommentError("Comment is required");
      return;
    }

    setCommentError("");

    handleConfirm(
      candidateDetails.appl_id,
      STATUS_MAP[actionType].code,
      trimmedComment,
      STATUS_MAP[actionType].label,
      selectedRemark?.id || null
    );
  };

  const clearFilters = () => {
    setGender("");
    setSelectedRoleOptions([]);
    setArea("");
    setState("");
    setCity("");
    setStartDate("");
    setEndDate("");
    setSource("");
    setnewTags("");
    setCurrentPage(1);
    setSizePerPage(10);
    setIsVisible(false);
    getPendingList();
    setIsFiltered(false);
    setType("");
  };

  const getFilterList = () => {
    let filterArray = [];

    // Add gender filter if selected
    if (gender) {
      filterArray.push({
        label: "gender",
        value: gender,
        key: "gender",
      });
    }
if (filters?.preferred_location?.length > 0) {
  filterArray.push({
    label: "city",
    value: filters.preferred_location.map(item => item.label).join(", "),
    key: "preferred_city",
  });
}
    // Add role filter if selected
    if (selectedRoleOptions?.length > 0) {
      filterArray.push({
        label: "job position",
        value: selectedRoleOptions.map(item => item.label).join(", "),
        key: "role",
      });
    }

    // Add source filter if selected
    if (source) {
      let sourceLabel = sourceType.find(el => el.value == source)?.label;
      filterArray.push({
        label: "source type",
        value: sourceLabel,
        key: "source",
      });
    }

    // Add state filter if selected
    if (state) {
      let stateLabel = states.find(el => el.value == state)?.label;
      filterArray.push({
        label: "state",
        value: stateLabel,
        key: "state",
      });
    }

    // Add city filter if selected
    if (city) {
      let cityLabel = filteredCities.find(el => el.value == city)?.label;
      filterArray.push({
        label: "city",
        value: cityLabel,
        key: "city",
      });
    }

    if (type !== "") {
      filterArray.push({
        label: t(`all-application.Date Range`),
        value:
          type === "current"
            ? t(`all-application.Current Month`)
            : type === "previous"
            ? t(`all-application.Last 3 Months`)
            : `Custom (${moment(getCompanyTimezoneDateTime(startDate)).format(
                "DD MMM YYYY"
              )} - ${moment(getCompanyTimezoneDateTime(endDate)).format(
                "DD MMM YYYY"
              )})`,
        key: "type",
      });
    }

    // Add tags filter if selected
    if (newtags) {
      let tagLabel = tags.find(el => el.value === newtags)?.label;
      filterArray.push({
        label: "tags",
        value: tagLabel,
        key: "tags",
      });
    }
  // console.log(filterArray,"filterArray")
    return filterArray;
  };


  const handleFilterRemove = key => {
// console.log(key,"key")
    const newState = {
      type: "pending",
      gender,
      role: selectedRoleOptions,
      source,
      state,
      city,
      tags,
      queryText: query,
      preferred_city: filters?.preferred_location || []
    };
    if (type) {
      newState.startDate = startDate;
      newState.endDate = endDate;
    }
    let defaultType = type;
    switch (key) {
      case "gender":
        setGender("");
        newState.gender = "";
        break;
      case "role":
        setSelectedRoleOptions([]);
        newState.role = [];
        break;
      case "source":
        setSource("");
        newState.source = "";
        break;
      case "state":
        setState("");
        setCity("");
        newState.state = "";
        newState.city = "";
        break;
      case "city":
        setCity("");
        newState.city = "";
        break;
      case "type":
        setType("");
        setStartDate("");
        setEndDate("");
        newState.startDate = "";
        newState.endDate = "";
        defaultType = "";
        break;
      case "tags":
        setnewTags("");
        newState.tags = "";
        break;
           case "preferred_city":
      setFilters(prev => ({
        ...prev,
        preferred_location: [], // ✅ CLEAR FILTER
      }));
      newState.preferred_city = [];
      break;
    }

    handleSubmit(newState, defaultType);
  };
  const cityColumn = {
  dataField: "master_city.city",
  text: t(`all-application.City`),
  classes: "application-normal",
};

  const tagsColumn = {
  dataField: "",
  text: t(`all-application.Tags`),
  classes: "application-normal tags-card",
  headerClasses: "application-normal tags-card",
  formatter: (cell, row) => {
    return (
      tags.length > 0 && (
        <SearchData
          applId={row.appl_id}
          getPendingList={getPendingList}
          tags={tags}
        />
      )
    );
  },
};

  const columns = [
    {
      dataField: "appl_id",
      text: t(`all-application.Appl No`),
      classes: "total app-col sticky-col",
      headerClasses: "app-col sticky-col",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              id={`checkbox-${row?.appl_id}`} // Unique ID for the input
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
              className="d-none"
            />
            <label
              htmlFor={`checkbox-${row?.appl_id}`}
              className="checkbox-label"
            >
              {formattedDate}
            </label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: t(`all-application.Name`),
      classes: "application-name name-col sticky-col",
      headerClasses: "name-col sticky-col",
      sort: true,
      formatter: (cell, row) => (
        <span
          className="clickable-link"
          style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/candidate_consolidate/view-details/${row.appl_id}`);
          }}
        >
          {cell?.toLowerCase()}
        </span>
      ),
    },
 
    {
      dataField: "email_id",
      text: t(`all-application.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "mobile",
      text: t(`all-application.Mobile No`),
      classes: "application-normal",
      formatter: (cell, row) => <>{generateMaskedPII(row?.mobile, 2)}</>,
    },
    {
      dataField: "job_user.master_reference_table.gender",
      text: t(`all-application.Gender`),
      classes: "application-normal",
      formatter: (cell, row) => {
        return cell ? t(`Gender.${cell}`) : t("Gender.Unknown");
      },
    },

    {
      dataField: "master_reference_table.highest_qualification",
      text: t(`all-application.Education`),
      classes: "application-normal educations",
      sort: true,
    },
    {
      dataField: "job_user.total_experience",
      text: t(`all-application.Total Exp`),
      classes: "application-normal",
      sort: true,
    },
    {
      dataField: "vacancy.title",
      text: t(`all-application.Job Role`),
      headerClasses: "application-normal education",
      classes: "application-normal education",
      sort: true,
    },
    {
      dataField: "vacancy.franchise.franchise_name",
      text: t(`all-application.dealer_name`),
      headerClasses: "application-normal education",
      classes: "application-normal education",
      sort: false,
    },
 ...(getSubdomain() !== "mahindra" ? [tagsColumn] : []),
   
     ...(getSubdomain() !== "mahindra" ? [cityColumn] : []),
         {
      dataField: "apply_date",
      text: t(`all-application.Applied on`),
      classes: "application-normal",
      sort: true,
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const today = new Date();
        const isToday = applyDate.toDateString() === today.toDateString(); // Compare date parts only

        const daysAgo = calculateDaysAgo(applyDate);

        return (
          <div className="date-tabel">
            <label>
              {isToday
                ? t(`all-application.Today`)
                : `${daysAgo} ${t(`all-application.days ago`)}`}
            </label>
          </div>
        );
      },
    },
      {
      dataField: "creator.name",
      text: t(`all-application.created_by`),
      classes: "application-normal",
    },
     {
      dataField: "",
      text: t(`all-application.Status`),
      classes: "Status-normal",
      headerClasses: "Status-normal",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        return (
          <div
            key={appl_id}
            className="action-application"
            title={`Please select ${t(
              "all-application.Status"
            )?.toLowerCase()}`}
          >
            <label htmlFor={`status-select-${appl_id}`} className="d-none">
              {t("all-application.Status")}
            </label>
            <Select
              id={`status-select-${appl_id}`} // Unique ID for the select
              className="w-100"
              placeholder={t("all-application.Pending")}
              options={statusUpdateOptions}
              onChange={e => {
                handleStatusChange(e, appl_id);
              }}
              isOptionDisabled={option => option?.disabled}
              components={{
                IndicatorSeparator: () => null, // Hides the separator, which might be focusable otherwise
              }}
              tabIndex={1} // Ensuring a positive tabindex value
              aria-labelledby="select-status-label"
            />
          </div>
        );
      },
    },
  
    {
      dataField: "Actions",
      text: t(`all-application.Actions`),
      classes: "total text-center Actions-acrd",
      headerClasses: "text-center  Actions-acrd",
      formatter: (cell, row) => {
        let appl_id = row?.appl_id;
        let dob = row?.job_user?.dob;
        let user_id = row?.user_id;
        let vacancy_id = row?.vacancyId;
        let created_time = row?.apply_date;
        //  console.log('cell',row);
        return (
          <div className="action-application  gap-space-assement">
            {checkPermissionStatus("pending-list", "assessment") && (
              <div className="action-ones">
                <Button
                  className="blue-color"
                  onClick={() =>
                    handleAssessmentStart(
                      vacancy_id,
                      user_id,
                      appl_id,
                      row?.name,
                      row?.vacancy?.title,
                      row,
                      created_time
                    )
                  }
                >
                  {subdomain !== "mahindra" ? (
                    <>
                      {t("all-application.Pending")}
                      <FontAwesomeIcon icon={faEdit} />
                    </>
                  ) : (
                    <>
                      {t("all-application.View")}
                      <FontAwesomeIcon icon={faEye} />
                    </>
                  )}
                </Button>
              </div>
            )}

            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  title="Actions"
                >
                  <img src={threedots} alt="Actions Menu" aria-hidden="true" />
                  <span className="visually-hidden d-none">
                    Open Actions Menu
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "view")}
                    onClick={() => {
                      history.push(`/printpending-list/${appl_id}`);
                    }}
                  >
                    {t(`all-application.Print Report`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "view")}
                    onClick={() => {
                      history.push(
                        `/candidate_consolidate/view-details/${appl_id}`
                      );
                    }}
                  >
                    {t(`all-application.View Details`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "edit")}
                    onClick={() =>
                      openUpdationModal("Edit Details", user_id, dob, row)
                    }
                  >
                    {t(`all-application.Edit Details`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "create")}
                    onClick={() => open_slider(appl_id, 0)}
                  >
                    {t(`all-application.Add Comment`)}
                  </Dropdown.Item>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("pending-list", "edit")}
                    onClick={() => handleUpload(user_id)}
                  >
                    {t(`all-application.Upload Resume`)}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
    // Add more columns as needed
  ];

  const statusUpdateOptions = [
    {
      label: (
        <>
          <div className="list-icons">
            <img src={pending_icon} alt="" /> {t(`all-application.Pending`)}
          </div>
        </>
      ),
      value: "pending",
    },
    // {
    //   label: (
    //     <>
    //       <img src={action2} alt="" /> {t(`all-application.On Hold`)}
    //     </>
    //   ),
    //   value: "hold",
    //   disabled: !checkPermissionStatus("pending-list", "onhold"),
    // },
    {
      label: (
        <>
          <img src={SelectedSVG} alt="" /> {t(`all-application.Shortlisted`)}
        </>
      ),
      value: "shortlist",
      // disabled: !checkPermissionStatus("pending-list", "shortlisted"),
      disabled: subdomain !== "mahindra",
    },
    {
      label: (
        <>
          <img src={action3} alt="" /> {t(`all-application.Rejected`)}
        </>
      ),
      value: "reject",
      disabled: !checkPermissionStatus("pending-list", "reject"),
    },
  ];

  const handleStatusChange = async (e, appl_id) => {
    const action = e?.value;

    if (action === "hold") {
      await handleConfirm(
        appl_id,
        STATUS_MAP.hold.code,
        "",
        STATUS_MAP.hold.label
      );
    } else if (["reject", "shortlist", "selectcandidate"].includes(action)) {
      open_slider(appl_id, STATUS_MAP[action].code, action);
    }
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (pendingData.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [pendingData.length]);

  ///modal
  const [isVisible, setIsVisible] = useState(false);

  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  const reject_close = () => {
    setIsReject(false);
    setCommentError("");
  };
  const hold_close = () => {
    setIsHold(false);
    setCommentError("");
  };
  const comment_close = () => {
    setIsComment(false);
    setCommentError("");
  };

  const open_slider = async (appl_id, status, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;

      if (data.status && data.data.length > 0) {
        setCandidateDetails(data.data[0]);
      }
    } catch (error) {}

    if (type != null) {
      setSelectedApplId(appl_id);
      setActionType(type);
      setIsReject(true);
    } else {
      if (status == 1) {
        setIsHold(!isHold);
      } else if (status == 2) {
        setIsReject(!isReject);
      } else {
        setIsComment(!isComment);
      }
    }
  };

  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [isCommentRequired, setIsCommentRequired] = useState(true);
  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const validateComment = () => {
    // if (isCommentRequired && !comment.trim()) {
    //   setCommentError(t(`all-application.Comment required`));
    //   return false;
    // }
    // You can add more validation rules here if needed
    return true;
  };
  const toggleCommentRequirement = () => {
    setIsCommentRequired(prevIsCommentRequired => !prevIsCommentRequired);
  };

  const handleGenderChange = e => {
    if (gender === e.target.name) {
      setGender("");
    } else {
      setGender(e.target.name);
    }
  };

  
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Effect to add class to modal backdrop when isModalOpen is true
  useEffect(() => {
    if (isModalOpen) {
      const timeout = setTimeout(() => {
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (modalBackdrop) {
          modalBackdrop.classList.add("edit-cksisjs");
        }
      }, 10); // Adjust the delay as necessary
      return () => clearTimeout(timeout);
    }
  }, [isModalOpen]);

  // Interview Schedules functions

  const handleTimeslotSubmit = event => {
    event.preventDefault();

    setErrors({});
    let errorObj = {};
    const errorMessages = [];

    let payload = new FormData();

    const mappedTimeSlots = Object.fromEntries(
      Object.entries(daytimeSlots)
        .map(([day, slots]) => {
          const integerKey = dayToIntegerMap[day];
          if (integerKey === undefined) return;
          return [integerKey, slots];
        })
        .filter(entry => entry !== undefined)
    );

    const timeSlotsobj = JSON.stringify(mappedTimeSlots, null, 2);

    payload.append("timeSlots", timeSlotsobj);

    // Log the FormData contents
    payload.forEach((value, key) => {});

    // Loop through each day in the ErrorsTimeslots object and extract the messages
    for (const [day, messages] of Object.entries(ErrorsTimeslots)) {
      // Check if the day contains any messages
      if (Array.isArray(messages) && messages.length > 0) {
        errorObj[day] = messages; // Keep track of errors per day
        // Push all non-empty error messages for the day into errorMessages
        messages.forEach(message => {
          if (message && message.trim() !== "") {
            // Check if message is not empty or only whitespace
            errorMessages.push(`${day}: ${message}`);
          }
        });
      } else {
        // If no messages, remove the day from ErrorsTimeslots
        delete ErrorsTimeslots[day];
      }
    }

    // Display the error messages, for example using toast
    if (errorMessages.length > 0) {
      toast.error(errorMessages.join("\n")); // Display each error on a new line
      setErrors(errorObj); // Set the error state for the form
      setIsLoading(false);
    } else {
      // Proceed to call the API if the payload is correct
      updateUserTimeslots(payload);
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  // Function to update user
  const updateUserTimeslots = payload => {
    const userId = formData?.interviewer_time || 0;
    if (!userId || userId === "0") {
      console.error("Invalid userId.");
      return; // Exit the function if userId is invalid
    }

    api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/user/update-usertimeslots/${userId}`,
        payload,
        {
        }
      )
      .then(response => {
        setIsLoading(false);
        setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin after success
        clearDtTime();

        // Show success toast
        toast.success(t(`all-application.Timeslots updated`));
      })
      .catch(err => {
        setIsLoading(false);
        console.log("Error:", err);

        // Show error toast (optional)
        toast.error(t(`all-application.Timeslots update failed`));
      });
  };

  // Fetch time slots based on interviewerID
  const fetchInterTimeslot = async (interviewer_id, date, type) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/user/fetch-timeslots/${interviewer_id}?date=${date}`,
        {
        }
      );

      const result = response.data;
      const { user } = result;
      const { timeSlots, bookedTimeSlots, timeSlotsData } = user;
      settimeSlotsData(timeSlotsData || {});
      if (Array.isArray(timeSlots)) {
        if (type === "start") {
          // Extract start times for the start time dropdown
          const startTimes = timeSlots.map(slot => slot.startTime);
          setsDateTimeSlots(startTimes); // Update start time slots state
        } else if (type === "end") {
          // Filter end times based on the selected start time
          const filteredTimeSlots = timeSlots.filter(slot =>
            moment(slot.startTime, "HH:mm").isSameOrAfter(
              moment(selectedStartTime, "HH:mm")
            )
          );

          if (filteredTimeSlots.length > 0) {
            const endTimes = filteredTimeSlots.map(slot => slot.endTime);
            seteDateTimeSlots(endTimes); // Update end time slots state
          } else {
            seteDateTimeSlots([]); // No available end time slots
            toast.error(t(`all-application.Timeslot err 5`));
          }
        }
      } else {
        console.error("timeSlots is not an array:", timeSlots);
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
    }
  };

  const clearDtTime = () => {
    setsDateTimeSlots([]);
    seteDateTimeSlots([]);
    setStartTime("");
    setEndTime("");
    setSelectedStartTime("");
    setSelectedEndTime("");
    setIsTimeslotBtnDisabled(true);
  };

  const handleDateChange = (date, type) => {
    let valid = true;
    const formattedDate = moment(getCompanyTimezoneDateTime(date)).format(
      "YYYY-MM-DD"
    );
    if (formData?.interviewer_time === "0") {
      clearDtTime();
      toast.error(t(`all-application.Please select Interviewer`));
      return false;
    }

    if (type === "start") {
      setSelectedStartTime("");
      setSelectedEndTime("");
      setEndTime("");
      setStartTime(formattedDate); // Update the start date
    } else if (type === "end") {
      setSelectedEndTime("");
      // Check if start date and start time are set before setting the end time
      if (!int_start_time) {
        toast.error(t(`all-application.Please select start date`));
        return false;
      }
      if (!selectedStartTime) {
        toast.error(t(`all-application.Please select start time`));
        return false;
      }
      setEndTime(formattedDate); // Set end date
    }
    const interviewerID = formData?.interviewer_time || 0;
    fetchInterTimeslot(interviewerID, formattedDate, type);
    // Enable button if interviewer_time is greater than zero
    setIsTimeslotBtnDisabled(interviewerID <= 0);
  };

  // Handle start time selection
  const handleStartTimeChange = time => {
    const selectedDate = new Date(int_start_time); // Date selected in DatePicker
    const [hours, minutes] = time.split(":");

    // Clone the selected date and set the selected time
    const selectedTime = new Date(selectedDate);
    selectedTime.setHours(hours);
    selectedTime.setMinutes(minutes);

    const currentDateTime = new Date(); // Get current date and time

    // Check if the selected start date is today
    const isToday =
      selectedDate.toDateString() === currentDateTime.toDateString();

    // Only perform the "must be in the future" validation if today is selected
    if (isToday && selectedTime <= currentDateTime) {
      // Set an error if the selected time is invalid and today is selected
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: t(`all-application.Selected time in future`),
      }));
    } else {
      // Clear the error if the time is valid or if the date is not today
      setErrors(prevErrors => ({
        ...prevErrors,
        selectedStartTime: "", // Clear the specific error for the start time
      }));

      // Update the state for selected time and reset end time slots
      setSelectedStartTime(time);
      seteDateTimeSlots([]); // Reset end time slots
      setEndTime(""); // Reset end time
      setSelectedEndTime(""); // Reset selected end time
    }
  };

  const handleEndTimeChange = e => {
    const selectedEnd = e.target.value;
    setSelectedEndTime(selectedEnd);

    if (selectedStartTime) {
      // Helper function to parse time
      const parseTime = time => {
        const [hours, minutes] = time.split(":").map(Number);
        const today = new Date();
        return new Date(today.setHours(hours, minutes, 0, 0)); // Set time to today's date
      };

      const startTime = parseTime(selectedStartTime);
      const endTime = parseTime(selectedEnd);
      const now = new Date(); // Current date and time

      // Check if the selected start date is today
      const selectedDate = new Date(int_start_time); // Assuming int_start_time is the selected start date
      const isToday = selectedDate.toDateString() === now.toDateString();

      // Validation: End time cannot be in the past or present only if today is selected
      if (isToday && endTime <= now) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 6`));
        return;
      }

      // Validation: End time must be after the selected start time
      if (endTime <= startTime) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 7`));
        return;
      }

      // Check for overlap with booked time slots
      const hasOverlap = bookedTimeSlots.some(slot => {
        const bookedStart = parseTime(slot.startTime);
        const bookedEnd = parseTime(slot.endTime);

        return startTime < bookedEnd && endTime > bookedStart;
      });

      if (hasOverlap) {
        setSelectedEndTime("");
        toast.error(t(`all-application.Timeslot err 8`));
        return;
      }

      // If validation passes, update formData
      setFormData(prevFormData => ({
        ...prevFormData,
        int_schedule_time: `${selectedStartTime} - ${selectedEnd}`,
      }));
    }
  };

  const handleAddTimeslotsClick = e => {
    e.preventDefault(); // Prevent the default form submission behavior
    setShowTimeslotBooking(true); // Show TimeslotBookingAdmin when the button is clicked
  };

  const handleCancelClick = e => {
    e.preventDefault(); // Prevent default behavior
    setShowTimeslotBooking(false); // Hide TimeslotBookingAdmin
  };

  const handleChildValueChange = value => {
    // Parse the JSON string into an object
    const jsonObject = JSON.parse(value);
    setDaytimeSlots(jsonObject);
  };

  // Function to update the state in the parent component errors
  const handleErrorsValueChange = errors => {
    // Parse the JSON string into an object
    // console.log(JSON.stringify(errors), "timeslotserrors");
    setErrorsTimeslots(errors);
  };

  const [activeRow, setActiveRow] = useState(null); // to track which row is expanded

  const toggleAccordion = index => {
    if (activeRow === index) {
      setActiveRow(null); // collapse if it's already open
    } else {
      setActiveRow(index); // expand the clicked row
    }
  };

  //peding-list

  const statusUpdateOptionsModal = [
    {
      label: (
        <>
          <div className="list-icons">
            <img src={pending_icon} alt="" /> {t(`all-application.Pending`)}
          </div>
        </>
      ),
      value: "pending",
    },
    {
      label: (
        <>
          <img src={action2} alt="" /> {t(`all-application.On Hold`)}
        </>
      ),
      value: "hold",
      disabled: !checkPermissionStatus("pending-list", "onhold"),
    },
    {
      label: (
        <>
          <img src={action3} alt="" /> {t(`all-application.Rejected`)}
        </>
      ),
      value: "reject",
      disabled: !checkPermissionStatus("pending-list", "reject"),
    },
  ];

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  //mobileview
  const tableWrapperRef1 = useRef(null);
  const handleScroll1 = direction => {
    if (tableWrapperRef1.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef1.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const tabWrapperRef = useRef(null);

  const scrollLeft = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = isLang1OrLang2 ? 30 : 20; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1280) {
      moveDistance = isLang1OrLang2 ? 30 : 20;
    } else if (window.innerWidth < 1280) {
      moveDistance = isLang1OrLang2 ? 60 : 50;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(${moveDistance}px)`;
    }
  };

  const scrollRight = () => {
    let moveDistance;

    // Check for 'lang-1' or 'lang-2' class on the body
    const bodyClassList = document.body.classList;
    const isLang1OrLang2 =
      bodyClassList.contains("lang-1") || bodyClassList.contains("lang-2");

    if (window.innerWidth >= 1400) {
      moveDistance = 150; // Adjust for 'lang-1' or 'lang-2'
    } else if (window.innerWidth >= 1280) {
      // Adjust based on lang-1 or lang-2
      if (bodyClassList.contains("lang-1")) {
        moveDistance = 380; // For lang-1
      } else if (bodyClassList.contains("lang-2")) {
        moveDistance = 100; // For lang-2
      } else {
        moveDistance = 380; // Default for 1280px+
      }
    } else if (window.innerWidth >= 1152) {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    } else {
      moveDistance = isLang1OrLang2 ? 510 : 490;
    }

    if (tabWrapperRef.current) {
      tabWrapperRef.current.style.transform = `translateX(-${moveDistance}px)`;
    }
  };

  const handleTableChange = (type, { page, sizePerPage: ps, sortField: sf }) => {
    if (type === "sort") {
      const newOrder = sf === sortField
        ? (sortOrder === "asc" ? "desc" : "asc")
        : "asc";
      setSortField(sf);
      setSortOrder(newOrder);
      setCurrentPage(1);
      if (isFiltered) {
        handleSubmit({
          type: "pending",
          gender, role: selectedRoleOptions, source, state, city, area,
          startDate, endDate, newtags,
          pageSize: ps || sizePerPage,
          page: 1,
          sortField: sf,
          sortOrder: newOrder,
        }, "");
      } else {
        getPendingList(1, ps || sizePerPage, query, sf, newOrder);
      }
    } else {
      setCurrentPage(page);
      setSizePerPage(ps);
      if (isFiltered) {
        handleSubmit({
          type: "pending",
          gender, role: selectedRoleOptions, source, state, city, area,
          startDate, endDate, newtags,
          pageSize: ps,
          page,
          ...(sortField && { sortField, sortOrder }),
        }, "");
      } else {
        getPendingList(page, ps, query, sortField, sortOrder);
      }
    }
  };

  const handleSearch = async () => {
    handleSubmit();
    setCurrentPage(1);
  };

  if (!checkPermissionStatus("pending-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`all-application.Access denied`)}</h4>
      </div>
    );
  }


  return (
    <>
      <ConfirmationModal
        show={showModal}
        handleClose={closeModal}
        handleConfirm={handleConfirm}
        message={modalMessage}
        appl_id={selectedApplId}
        status={selectedStatus}
      />
      <UpdationModal
        show={showUpdationModal}
        handleUpdationClose={closeUpdationModal}
        handleUpdation={handleUpdation}
        message={modalMessage}
        user_id={selectedUserID}
        initialDOB={selectedDOB}
      />
      <UploadModal
        show={showUploadModal}
        handleUpdationClose={closeUploadModal}
        handleUpdation={handleUpload}
        message={modalMessage}
        user_id={selectedUserID}
      />

      <div className="pending-list-page">
        <div className="tabbing-wrapper allap d-flex justify-content-between mt-2 mb-4 position-relative">
          <button className="arrow-btns" onClick={scrollLeft}>
            <img src={right_arrow} alt="left-arrow" />
          </button>
          <button className="arrow-btns right" onClick={scrollRight}>
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul
              className="tab-btn-wrapper d-flex align-items-center"
              ref={tabWrapperRef}
              style={{ transition: "transform 0.3s" }}
            >
              <li>
                <Link
                  to={`/all-applications${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="all-applications"
                >
                  {t(`all-application.All Applications`)}
                </Link>
              </li>

              <li>
                <Link
                  to={`/pending-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link active"
                  id="pending-list"
                >
                  {t(`all-application.New Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/screening-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="screening-list"
                >
                  {t(`all-application.In Progress Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/selected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="selected-list"
                >
                  {t(`all-application.Selected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onboarded-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onboarded-list"
                >
                  {t(`all-application.Onboarded Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/onhold-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="onhold-list"
                >
                  {t(`all-application.Onhold Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/rejected-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="rejected-list"
                >
                  {t(`all-application.Rejected Applications`)}
                </Link>
              </li>
              <li>
                <Link
                  to={`/archive-list${type ? "?filterValue=true" : ""}`}
                  className="tab-link"
                  id="archive-list"
                >
                  {t(`all-application.Archived Applications`)}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="outerTab-box-wrapper applicationcard-table mobile-cards-view allapp-cation">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive pb-3 table-height">
                <div className="table-data-search">
                  <div className="total-record">
                    <h5>
                      {t(`all-application.Total Records`)}{" "}
                      <span>{totalCounts || 0}</span>
                    </h5>
                  </div>
                  <div className="total-serachbar">
                    <SearchBar
                      onSearch={handleSearch}
                      title={t(`all-application.Search by mobile2`)}
                      placeholder={
                        t(`all-application.Search by mobile`).slice(0, 40) +
                        "..."
                      }
                      query={query}
                      setQuery={setQuery}
                    />
                    {/* <div className="take-text">
                      <h5>{t(`all-application.Take Test`)}</h5>
                    </div> */}

                    {/* <div className="take-text">
                      <Link to="">
                        <Button
                          color="info"
                          onClick={e => handleCSVDownload(e)}
                          outline
                        >
                          <img src={mail_csv} alt="Download" />
                          {t(`all-application.Send CSV via Mail`)}
                        </Button>
                      </Link>
                    </div> */}

                    {checkPermissionStatus("pending-list", "downloadcsv") && (
                      <div className="take-text">
                        <CSVLink
                          data={csvData}
                          headers={[
                            {
                              key: "appl_id",
                              label: t(`all-application.Application ID`),
                            },
                            {
                              key: "name",
                              label: t(`all-application.Name`),
                            },
                            {
                              key: "mobile",
                              label: t(`all-application.Mobile Number`),
                            },
                            {
                              key: "email_id",
                              label: t(`all-application.Email ID`),
                            },
                            {
                              key: "createdAt",
                              label: t(`all-application.Created Date`),
                            },
                            {
                              key: "f2f_address",
                              label: t(`all-application.Address`),
                            },
                          ]}
                          filename={`PendingApplicationList.csv`}
                          id="downloadCSV"
                        >
                          <Button
                            color="info"
                            onClick={e => handleCSVDownload(e)}
                            outline
                          >
                            <img src={dowanload_csv} alt="Download" />{" "}
                            {t(`all-application.Download CSV`)}
                          </Button>
                        </CSVLink>
                      </div>
                    )}
                    <div className="take-text filter" onClick={filter_icon}>
                      <h5>
                        <span>
                          <img src={filtericon} alt="filter icon" />
                        </span>
                        {t(`all-application.Filters`)}
                      </h5>
                    </div>

                    <div className="tale-text right-panel alapp arrow-btns">
                      <button
                        className="button left"
                        onClick={() => handleScroll("left")}
                        data-tooltip="Scroll Left"
                      >
                        <img src={right_arrow} alt="left-arrow" />
                      </button>
                      <button
                        className="button right"
                        onClick={() => handleScroll("right")}
                        data-tooltip="Scroll Right"
                      >
                        <img src={right_arrow} alt="right-arrow" />
                      </button>
                    </div>
                  </div>
                </div>

                {getFilterList()?.length > 0 && (
                  <div className="selected-data-card length-selected-data allapp mb-4">
                    {getFilterList()?.map((el, index) => {
                      return (
                        <div className="select-para" key={index}>
                          <p className="mb-0">
                            <span className="selected-tag text-capitalize">
                              {el?.label} - {el?.value}
                            </span>
                            <button
                              className="remove-tag-button"
                              onClick={() => handleFilterRemove(el?.key)}
                            >
                              &times;
                            </button>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* <div className="table-data-search panel">
                  
                </div> */}

                <div className="timeto-hire-card userlist pendiglist-cardss">
                  {loading && (
                    <div className="m-3 p-3 text-center">
                      <Spinner size={"lg"} />{" "}
                      <div>{t(`all-application.Loading`)}</div>
                    </div>
                  )}
                  {!loading && (
                    <div className="table-custome-class range-custome">
                      {pendingData?.length > 0 ? (
                        <>
                          <div className="scroll-container">
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <RemotePagination
                                keyField="appl_id"
                                data={pendingData}
                                columns={columns}
                                page={currentPage}
                                sizePerPage={sizePerPage}
                                totalSize={totalCounts}
                                onTableChange={handleTableChange}
                                rowClasses={rowClasses}
                                sortField={sortField}
                                sortOrder={sortOrder}
                              />
                              {/* <BootstrapTable
                                keyField="id"
                                data={pendingData?.filter(renderCheck)}
                                columns={columns}
                                pagination={paginationFactory(options)}
                                rowClasses={rowClasses}
                                hover
                                responsive
                                key={tags.length}
                              /> */}
                            </div>
                          </div>
                        </>
                      ) : (
                        <table className="table table-hover table-bordered">
                          <thead>
                            <tr>
                              <th>{t(`all-application.Appl No`)}</th>
                              <th>{t(`all-application.Name`)}</th>
                              <th>{t(`all-application.created_by`)}</th>
                              <th>{t(`all-application.Email Id`)}</th>
                              <th>{t(`all-application.Mobile No`)}</th>
                              <th>{t(`all-application.Gender`)}</th>
                              <th>{t(`all-application.Education`)}</th>
                              <th>{t(`all-application.Total Exp`)}</th>
                              <th>{t(`all-application.Job Role`)}</th>
                              <th>{t(`all-application.City`)}</th>
                              <th>{t(`all-application.Actions`)}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="10" className="text-center">
                                <div className="no-data data-available">
                                  <img
                                    src="../img/data-not-available.png"
                                    alt="data not availble"
                                  />
                                  <h3>{t(`all-application.No Item Found`)}</h3>
                                  <p>
                                    <Trans>
                                      {t(`all-application.No Item Msg`)}
                                    </Trans>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isVisible && (
            <div className="filter-shadow filetr-cards">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Filters`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={close}>
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="application-gender">
                  <h5>{t(`Bulk Import.Select Applicant Gender`)}</h5>

                  <div className="application-button">
                    <div className="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Male"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Male"}
                        />
                        <span>{t(`Gender.Male`)}</span>
                      </label>
                    </div>
                    <div className="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Female"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Female"}
                        />
                        <span>{t(`Gender.Female`)} </span>
                      </label>
                    </div>
                    <div className="cat action">
                      <label>
                        <input
                          type="checkbox"
                          name="Other"
                          onChange={e => handleGenderChange(e)}
                          checked={gender === "Other"}
                        />
                        <span>{t(`Gender.Other`)}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="filter-cards-form">
                  <form className="form-inline">
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Job Position")}</label>
                      <div
                        title={
                          selectedRoleOptions.length
                            ? `${selectedRoleOptions
                                .map(option => option.label || option.name)
                                .join(", ")}`
                            : `Please ${t("ATS View.Select Job Position")}`
                        }
                      >
                        <MultiSelect
                          options={roleTypes}
                          value={selectedRoleOptions}
                          onChange={setSelectedRoleOptions}
                          labelledBy="Select Job Position"
                          placeholder="Select"
                          overrideStrings={{
                            selectSomeItems: t("ATS View.Select Job Position"),
                          }}
                        />
                      </div>
                    </div>
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Source Type")}</label>

                      <div
                        title={`${
                          source
                            ? sourceType.find(el => el.value == source)?.label
                            : t("ATS View.Select Source Type")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setSource(e.target.value)}
                          aria-label="Default select example"
                          value={source}
                        >
                          <option value="">
                            {t("ATS View.Select Source Type")}
                          </option>
                          {sourceType?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}

{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select State")}</label>

                      <div
                        title={`${
                          state
                            ? states.find(el => el.value == state)?.label
                            : t("ATS View.Select State")
                        }`}
                      >
                        <Form.Select
                          onChange={e => handleStateChange(e)}
                          aria-label="Default select example"
                          value={state}
                        >
                          <option value="">{t("ATS View.Select State")}</option>
                          {states?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select City")}</label>

                      <div
                        title={`${
                          city
                            ? filteredCities.find(el => el.value == city)?.label
                            : t("ATS View.Select City")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setCity(e.target.value)}
                          aria-label="Default select example"
                          value={city}
                        >
                          <option value="">{t("ATS View.Select City")}</option>
                          {filteredCities?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
                    {/* <div className="col-lg-12">
                      <label>Select Area</label>
                      <Form.Select
                        onChange={e => setArea(e.target.value)}
                        aria-label="Default select example"
                        value={area}
                      >
                        <option value="">Select Area</option>
                        {areas?.map(el => {
                          return <option value={el?.value}>{el?.label}</option>;
                        })}
                      </Form.Select>
                    </div> */}

                    {/* <div className="col-lg-12">
                    <Form.Group
                      controlId="formDate"
                      className="input-formtext d-flex"
                    >
                      <span>Start Date :</span>
                      <input
                        type="date"
                        class="form-control"
                        id="date"
                        onChange={(e) => setStartDate(e.target.value)}
                        placeholder="Start Date"
                        value={startDate}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-lg-12">
                    <Form.Group
                      controlId="formDate"
                      className="input-formtext d-flex"
                    >
                      <span>End Date :</span>
                      <input
                        type="date"
                        class="form-control"
                        id="date"
                        onChange={(e) => setEndDate(e.target.value)}
                        value={endDate}
                      />
                    </Form.Group>
                  </div> */}
 <Col md={12}>
                      <Form.Group className="mb-3 floating-label">
                        <Form.Label className="float-label">
                          {t(`all-application.City`)}
                        </Form.Label>
                        <div style={{ position: "relative" }}>
                          {/* INPUT */}
                          <input
                            type="text"
                            placeholder="Search City"
                            value={searchText}
                            className="form-control"
                            onChange={e => handleSearchCity(e.target.value)}
                          />

                          {/* SELECTED CHIPS */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "5px",
                              gap: "5px",
                            }}
                          >
                            {(filters?.preferred_location || []).map(
                              (item, index) => (
                                <div
                                  key={index}
                                  style={{
                                    background: "#e6f0ff",
                                    padding: "5px 10px",
                                    borderRadius: "20px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  {item.label}
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      const updated =
                                        filters.preferred_location.filter(
                                          el => el.value !== item.value
                                        );
                                      setFilters({
                                        ...filters,
                                        preferred_location: updated,
                                      });
                                    }}
                                  >
                                    ×
                                  </span>
                                </div>
                              )
                            )}
                          </div>

                          {/* DROPDOWN */}
                          {cityOptions.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "40px",
                                left: 0,
                                right: 0,
                                background: "#fff",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                maxHeight: "150px",
                                overflowY: "auto",
                                zIndex: 9999,
                              }}
                            >
                              {cityOptions.map((item, index) => {
                                const alreadySelected = (
                                  filters?.preferred_location || []
                                ).some(el => el.value === item.location);

                                return (
                                  <div
                                    key={index}
                                    style={{
                                      padding: "8px",
                                      cursor: "pointer",
                                      background: alreadySelected
                                        ? "#f5f5f5"
                                        : "#fff",
                                    }}
                                    onClick={() => {
                                      if (alreadySelected) return;

                                      const updated = [
                                        ...(filters?.preferred_location || []),
                                        {
                                          label: item.location,
                                          value: item.location,
                                        },
                                      ];

                                      setFilters({
                                        ...filters,
                                        preferred_location: updated,
                                      });

                                      setSearchText("");
                                      setCityOptions([]);
                                    }}
                                  >
                                    {item.location}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="float-label">
                          {t(`all-application.Custom Date Range`)}
                        </Form.Label>
                        <div className="application-button mb-2">
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Current"}
                                onChange={e => {
                                  if (type === "curent") {
                                    setType("");
                                  } else {
                                    setType("current");
                                  }
                                }}
                                checked={type === "current"}
                              />
                              <span>{t(`all-application.Current`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Last 3 Months"}
                                onChange={e => {
                                  if (type === "previous") {
                                    setType("");
                                  } else {
                                    setType("previous");
                                  }
                                }}
                                checked={type === "previous"}
                              />
                              <span>{t(`all-application.Last 3 Months`)}</span>
                            </label>
                          </div>
                          <div className="cat action">
                            <label>
                              <input
                                type="checkbox"
                                name={"Custom"}
                                onChange={e => {
                                  if (type === "custom") {
                                    setType("");
                                  } else {
                                    setType("custom");
                                  }
                                }}
                                checked={type === "custom"}
                              />
                              <span>{t(`all-application.Custom`)}</span>
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    {type === "custom" && (
                      <>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.Start Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.Start Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setStartDate(e);
                              }}
                              placeholderText={t(`all-application.Start Date`)}
                              id="date"
                              selected={startDate}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.End Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.End Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setEndDate(e);
                              }}
                              placeholderText={t(`all-application.End Date`)}
                              id="date"
                              selected={endDate}
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
{getSubdomain() !== "mahindra" && (
                    <div className="col-lg-12">
                      <label>{t("ATS View.Select Tags")}</label>

                      <div
                        title={`${
                          newtags
                            ? tags.find(el => el.value == newtags)?.label
                            : t("ATS View.Select Tags")
                        }`}
                      >
                        <Form.Select
                          onChange={e => setnewTags(e.target.value)}
                          aria-label="Default select example"
                          value={newtags}
                        >
                          <option value="">{t("ATS View.Select Tags")}</option>
                          {tags?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    </div>
)}
                  </form>
                  <div className="col-lg-12">
                    <div className="serach-btn">
                      <button
                        className="btn btn-primary reset"
                        onClick={() => clearFilters()}
                      >
                        {t(`ATS View.Reset`)}
                      </button>
                      <button
                        className="btn btn-primary search"
                        onClick={() => handleSubmit()}
                      >
                        {t(`ATS View.Search`)}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* reject data popup */}
          {isReject && (
            <div className="filter-shadow reject-people-data">
              {/* ✅ backdrop FIRST */}
              <div className="black-showd" onClick={reject_close}></div>

              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>
                      {actionType === "reject"
                        ? t("all-application.Reject Application")
                        : t("all-application.Shortlist Application")}
                    </h4>
                  </div>
                  <div className="filter-content cross" onClick={reject_close}>
                    <img src={cross} alt="" />
                  </div>
                </div>

                <div className="reject-people data">
                  <div className="data-people">
                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={name_icon} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t("all-application.Name")}</p>
                        <h4>{candidateDetails.name}</h4>
                      </div>
                    </div>

                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={job} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t("all-application.Job Role")}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>
                  </div>

                  <div className="data-people">
                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={education} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t("all-application.Education")}</p>
                        <h4>
                          {
                            candidateDetails.master_reference_table
                              ?.highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={star_exp} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t("all-application.Total Exp")}</p>
                        <h4>{candidateDetails.job_user?.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-cards-form reject-data">
                  <h4>
                    {actionType === "reject"
                      ? t("all-application.Reject Candidate confirmation")
                      : t("all-application.Shortlist Candidate confirmation")}
                  </h4>

                  <p>
                    {actionType === "reject"
                      ? t("all-application.Reject Candidate msg")
                      : t("all-application.Shortlist Candidate msg")}
                  </p>

                  {actionType === "reject" && (
                    <Form.Group className="form-considere mb-2">
                      <Form.Label>Rejected Remark</Form.Label>
                      <Form.Select
                        value={selectedRemark?.id || ""}
                        onChange={handleRemarkChange}
                      >
                        <option value="">Select rejection reason</option>
                        {remarks.map(r => (
                          <option key={r.id} value={r.id}>
                            {r.remark_label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  )}

                  <form className="form-inline">
                    <div className="col-lg-12">
                      {/* {actionType !== "reject" && (
                        <Form.Group className="form-considere">
                          <Form.Check
                            type="checkbox"
                            label="Require comment"
                            checked={isCommentRequired}
                            onChange={toggleCommentRequirement}
                            disabled={true}
                          />
                        </Form.Group>
                      )} */}

                      <textarea
                        className="form-control"
                        rows="3"
                        name="comment"
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                        placeholder={
                          actionType === "reject"
                            ? selectedRemark?.is_comment_required
                              ? t("all-application.Reject Comment")
                              : t("all-application.Optional Comment")
                            : t("all-application.Shortlist Comment")
                        }
                      />

                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </div>

                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <a
                          href="javascript:void(0);"
                          className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                          onClick={!isLoading ? handleActionSubmit : undefined}
                          style={isLoading ? { pointerEvents: "none", opacity: 0.6 } : {}}
                        >
                          {isLoading
                            ? t("all-application.Please wait...")
                            : actionType === "reject"
                            ? t("all-application.Reject")
                            : actionType === "shortlist"
                            ? t("all-application.shortlist")
                            : t("all-application.Select")}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* reject data popup */}
          {/* Onhold data popup */}
          {isHold && (
            <div className="filter-shadow reject-people-data">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Hold Application`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={hold_close}>
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="reject-people data">
                  <div className="data-people">
                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={name_icon} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Name`)}</p>
                        <h4>{candidateDetails.name}</h4>
                      </div>
                    </div>

                    <div className="people-biodata job-icon">
                      <div className="icon-name">
                        <img src={job} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Job Role`)}</p>
                        <h4>{candidateDetails.vacancy?.title}</h4>
                      </div>
                    </div>
                  </div>

                  <div className="data-people ">
                    <div className="people-biodata job-icon">
                      <div className="icon-name">
                        <img src={education} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Education`)}</p>
                        <h4>
                          {
                            candidateDetails.master_reference_table
                              ?.highest_qualification
                          }
                        </h4>
                      </div>
                    </div>

                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={star_exp} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-cards-form reject-data">
                  <h4>{t(`all-application.Hold Candidate confirmation`)}</h4>
                  <p>{t(`all-application.Hold Candidate msg`)}</p>
                  <form className="form-inline">
                    <div className="col-lg-12">
                      <Form.Group>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder={t(`all-application.Optional Comment`)}
                          rows="3"
                          name="comment"
                          onChange={handleChange}
                        ></textarea>
                      </Form.Group>
                      {commentError && (
                        <div className="text-danger">{commentError}</div>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <a
                          href="javascript:void(0);"
                          id="next"
                          className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                          onClick={() =>
                            handleConfirm(
                              candidateDetails.appl_id,
                              4,
                              comment,
                              "Onhold"
                            )
                          }
                        >
                          {t(`all-application.Hold`)}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="black-showd"></div>
            </div>
          )}
          {/* reject data popup */}
          {/* Comment data popup */}
          {isComment && (
            <div className="filter-shadow reject-people-data">
              <div className="filters-cards">
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Comment Application`)}</h4>
                  </div>
                  <div className="filter-content cross" onClick={comment_close}>
                    <img src={cross} alt="" />
                  </div>
                </div>

                <div className="bordertops"></div>

                <div className="reject-people data justify-content-between">
                  <div className="mobile-cards align-items-center">
                    <div className="reject-perople-user">
                      <img
                        src={selectedCandidate?.candidate_photo || user_icons1}
                        alt="user icon"
                        className={
                          selectedCandidate?.candidate_photo
                            ? "image-upload"
                            : "iconuse"
                        }
                      />
                    </div>

                    <div className="header-plant">
                      <h4> {candidateDetails.name}</h4>
                    </div>
                  </div>

                  <div className="reject-people-user-data">
                    <div className="header-plant ss">
                      <h4> {candidateDetails.name}</h4>
                    </div>

                    <div className="reject-people-user-data-card">
                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Job Role`)}</p>
                          <h4> {candidateDetails.vacancy?.title}</h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Education`)}</p>
                          <h4>
                            {" "}
                            {
                              candidateDetails.master_reference_table
                                ?.highest_qualification
                            }
                          </h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="people-name">
                          <p>{t(`all-application.Total Exp`)}</p>
                          <h4>{candidateDetails.job_user.total_experience}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="reject-people data">
                  <div className="data-people">
                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={name_icon} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Name`)}</p>
                        <h4>{candidateDetails.name}</h4>
                      </div>
                    </div>




                    <div className="people-biodata">
                      <div className="icon-name">
                        <img src={star_exp} alt="" />
                      </div>
                      <div className="people-name">
                        <p>{t(`all-application.Total Exp`)}</p>
                        <h4>{candidateDetails.job_user.total_experience}</h4>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="filter-cards-form reject-data">
                  <h4>{t(`all-application.Enter Comment`)}</h4>
                  <p>{t(`all-application.Add Comment`)}</p>
                  <form className="form-inline">
                    <div className="col-lg-12">
                      <Form.Group>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          placeholder={t(`all-application.Compulsory Comment`)}
                          rows="3"
                          name="comment"
                          onChange={handleChange}
                        ></textarea>
                        {commentError && (
                          <div className="text-danger">{commentError}</div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-lg-12">
                      <div className="serach-btn">
                        <a
                          href="javascript:void(0);"
                          id="next"
                          className="nxt_prev_ques btn btn-primary btn-lg next-btn"
                          onClick={() =>
                            handleConfirm(candidateDetails.appl_id, 0, comment)
                          }
                        >
                          {t(`all-application.Comment`)}
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="black-showd"></div>
            </div>
          )}
          {/* Comment data popup */}

          <div className="edit-modal">
            <Modal
              size="lg"
              show={assessmentModal}
              onHide={() => handleCloseAssessmentModal()}
              className="edit-modal-card asseentModal screeningtest pedn"
            >
              {/* <Modal.Header closeButton>
                <Modal.Title>Assessment Center</Modal.Title>
              </Modal.Header> */}
              <Modal.Body>
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Assessment Center`)}</h4>
                  </div>
                  <div
                    className="filter-content cross"
                    onClick={handleCloseAssessmentModal}
                  >
                    <img src={cross} alt="" />
                  </div>
                </div>
                <div className="bordertops"></div>
                <div className="row  invite-for-interview pending-cardp">
                  <div className="p-0">
                    <div className="reject-people data justify-content-between">
                      <div className="mobile-cards">
                        <div className="reject-perople-user">
                          {/* {console.log(selectedCandidate)} */}
                          <img
                            src={
                              selectedCandidate?.candidate_photo || user_icons1
                            }
                            alt="user icon"
                            className={
                              selectedCandidate?.candidate_photo
                                ? "image-upload"
                                : "iconuse"
                            }
                          />
                        </div>
                        <div className="header-plant">
                          <h4> {selectedCandidate?.name}</h4>
                        </div>
                      </div>

                      <div className="reject-people-user-data">
                        <div className="header-plant  ss">
                          <h4
                            onClick={() => {
                              history.push(
                                `/candidate_consolidate/view-details/${selectedCandidate.appl_id}`
                              );
                            }}
                          >
                            {" "}
                            {selectedCandidate?.name}
                          </h4>
                        </div>

                        <div className="reject-people-user-data-card">
                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`ATS View.Job Role`)}</p>
                              <h4> {selectedCandidate?.roleType}</h4>
                            </div>
                          </div>

                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`ATS View.Highest education`)}</p>
                              <h4>
                                {
                                  selectedCandidate?.allInfo
                                    ?.master_reference_table
                                    ?.highest_qualification
                                }{" "}
                              </h4>
                            </div>
                          </div>

                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`View Details.Total Experience`)}</p>
                              <h4>
                                {selectedCandidate?.allInfo?.job_user
                                  ?.total_experience + t(`View Details.Years`)}
                              </h4>
                            </div>
                          </div>

                          <div className="people-biodata pb-0">
                            <div className="people-name">
                              <p>{t(`ATS View.Applied on`)}</p>
                              <h4>
                                {formatDate(selectedCandidate?.createdAt)}
                              </h4>
                            </div>
                          </div>

                          {selectedCandidate?.allInfo?.job_user?.resume && (
                            <div className="people-biodata resume-last pb-0">
                              <div className="people-name">
                                <p>{t(`View Details.Resume`)}</p>
                                <h4
                                  onClick={() =>
                                    window.open(
                                      `${selectedCandidate?.allInfo?.job_user?.resume}`,
                                      "_blank"
                                    )
                                  }
                                >
                                  <span className="filter-content cross">
                                    {t(`View Details.View Resume`)}
                                  </span>
                                </h4>
                              </div>
                            </div>
                          )}
                          <a
                            className="feedback_interview"
                            onClick={() => {
                              setAssessmentModal(false);
                              handleNotes();
                            }}
                          >
                            <img src={addnotoes} alt="write_feedback" />
                            View Notes
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* <div className="reject-people data justify-content-between">
                      <div className="people-biodata pb-0">
                        <div className="icon-name">
                          <img src={name_icon} alt="" />
                        </div>
                        <div className="people-name">
                          <p>{t(`all-application.Candidate Name`)}</p>
                          <h4>{selectedCandidate?.name}</h4>
                        </div>
                      </div>

                      <div className="people-biodata pb-0">
                        <div className="icon-name accordion-img round">
                          <img src={job} alt="" />
                        </div>
                        <div className="people-name">
                          <p>{t(`all-application.Role Type`)}</p>
                          <h4> {selectedCandidate?.roleType}</h4>
                        </div>
                      </div>
                    </div> */}
                  </div>

                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                    <div className="mt-1 aaessment-card-center pendinglist-cards p-0  view-details-card">
                      <div className="tale-text right-panel  mobile-arrow">
                        <button
                          className="button left"
                          onClick={() => handleScroll1("left")}
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll1("right")}
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                      {roundListData?.length > 0 && (
                        <div className="table-custome-class range-custome">
                          <>
                            <div className="scroll-container">
                              <div className="table-pending-list">
                                <div className="scroll-container">
                                  <div
                                    className="table-wrapper"
                                    ref={tableWrapperRef1}
                                  >
                                    <table className="table table-striped table-responsive table-bordered">
                                      <thead>
                                        <tr>
                                          <th>
                                            {t(`all-application.Round Name`)}
                                          </th>
                                          <th>
                                            {t(`all-application.Round Type`)}
                                          </th>
                                          {/* <th>Date</th>
                            <th>Time</th> */}
                                          <th>
                                            {t(`all-application.Round Status`)}
                                          </th>
                                          <th>{t(`all-application.Action`)}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {roundListData?.length > 0 &&
                                          roundListData?.map((el, index) => {
                                            return (
                                              <tr
                                                className="accrodion-cards-header text-start"
                                                eventKey={`${index}`}
                                              >
                                                <td className="accrodion-cards-header text-start">
                                                  <h5>{el?.roundName}</h5>
                                                </td>

                                                <td className="accrodion-cards-header text-start">
                                                  <h5>{el?.roundType}</h5>
                                                </td>

                                                {/* <td className="accrodion-cards-header">
                                    <h5></h5>
                                  </td>

                                  <td className="accrodion-cards-header">
                                    <h5></h5>
                                  </td> */}

                                                <td className="accrodion-cards-header text-start">
                                                  <h5>{el?.roundStatus}</h5>
                                                </td>

                                                <td>
                                                  <div className="action-application  gap-space-assement">
                                                    {el?.roundStatus ===
                                                      "Pending" &&
                                                      el?.isCurrentRound &&
                                                      el?.roundType ===
                                                        "Interview" && (
                                                        <div className="text-center width-round w-auto">
                                                          <button
                                                            className="btn btn-primary"
                                                            onClick={() =>
                                                              handleInterviewModal(
                                                                el?.roundId,
                                                                el?.roundType,
                                                                el?.roundName,
                                                                el?.interviewer?.user?.id,
                                                                el?.meeting_type,
                                                              )
                                                            }
                                                          >
                                                            {t(
                                                              `all-application.Schedule Round`
                                                            )}
                                                          </button>
                                                        </div>
                                                      )}

                                                    {el?.roundStatus ===
                                                      "Pending" &&
                                                      !el?.isCurrentRound && (
                                                        <div className="text-center red-colors width-round w-auto">
                                                          <Trans>
                                                            {t(
                                                              `all-application.Previous Round Pending`
                                                            )}
                                                          </Trans>
                                                        </div>
                                                      )}
                                                    {el?.roundStatus ===
                                                      "Pending" &&
                                                      el?.isCurrentRound &&
                                                      el?.roundType ===
                                                        "Test" && (
                                                        <div className="text-center  width-round w-auto">
                                                          <button
                                                            className="btn btn-primary"
                                                            onClick={() =>
                                                              handleScreenTest(
                                                                el?.roundId,
                                                                selectedCandidate?.appl_id,
                                                                selectedCandidate?.user_id,
                                                                selectedCandidate?.vacancy_id,
                                                                1
                                                              )
                                                            }
                                                          >
                                                            {t(
                                                              `all-application.Send Assessment`
                                                            )}
                                                          </button>
                                                        </div>
                                                      )}
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      )}

                      {/* <div
                        class="accrodion-cards-panel"
                        // defaultActiveKey={["0", "1", "2", "3"]}
                      >
                        {roundListData?.length > 0 &&
                          roundListData?.map((el, index) => {
                            return (
                              <div
                                className="accrodion-cards-item"
                                eventKey={`${index}`}
                              >
                                <div className="accrodion-cards-header">
                                  <h5>
                                    {el?.roundName} [{el?.roundStatus}]
                                  </h5>
                                </div>
                                <div className="accrodion-cards-body">
                                  <div className="d-flex gap-4 pending-card">
                                    <div className="acordion-ca">
                                      <div className="accordion-img">
                                        <img src={name_icon} alt="" />
                                      </div>
                                      <div className="accordion-heading">
                                        <strong>Round Name:</strong>{" "}
                                        <h5>{el?.roundName}</h5>
                                      </div>
                                    </div>

                                    <div className="acordion-ca ">
                                      <div className="accordion-img round">
                                        <img src={archive_book} alt="" />
                                      </div>
                                      <div className="accordion-heading">
                                        <strong>Round Type:</strong>{" "}
                                        <h5>{el?.roundType}</h5>
                                      </div>
                                    </div>

                                    <div className="acordion-ca">
                                      <div className="accordion-img round">
                                        <img src={menu_board} alt="" />
                                      </div>
                                      <div className="accordion-heading">
                                        <strong>Round Status:</strong>{" "}
                                        <h5>{el?.roundStatus}</h5>
                                      </div>
                                    </div>

                                    {el?.roundStatus === "Pending" &&
                                      el?.isCurrentRound &&
                                      el?.roundType === "Interview" && (
                                        <div className="text-center">
                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              handleInterviewModal(
                                                el?.roundId,
                                                el?.roundType,
                                                el?.roundName
                                              )
                                            }
                                          >
                                            Schedule Round
                                          </button>
                                        </div>
                                      )}
                                    {el?.roundStatus === "Pending" &&
                                      el?.isCurrentRound &&
                                      el?.roundType === "Test" && (
                                        <div className="text-center">
                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              handleScreenTest(
                                                el?.roundId,
                                                selectedCandidate?.appl_id,
                                                selectedCandidate?.user_id,
                                                selectedCandidate?.vacancy_id,
                                                1
                                              )
                                            }
                                          >
                                            Start Assessment
                                          </button>
                                        </div>
                                      )}
                                    {el?.roundStatus === "Pending" &&
                                      !el?.isCurrentRound && (
                                        <div className="text-center red-colors">
                                          Previous Round is <br /> Pending
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div> */}
                    </div>
                  )}
                </div>
              </Modal.Body>
            </Modal>
          </div>

          <div className="edit-modal">
            <Modal
              size="xl"
              show={isFormVisible}
              onHide={() => handleToggleForm()}
              className="edit-modal-card pendingcard scheule"
            >
              {/* <Modal.Header closeButton>
                <Modal.Title>Schedule Interview</Modal.Title>
              </Modal.Header> */}
              <Modal.Body>
                <div className="filters-cards-cross">
                  <div className="filter-content">
                    <h4>{t(`all-application.Schedule Interview`)}</h4>
                  </div>
                  <div
                    className="filter-content cross"
                    onClick={handleToggleForm}
                  >
                    <img src={cross} alt="" />
                  </div>
                </div>
                <Form
                  onSubmit={handleInterviewSubmit}
                  className="form-modal pt-0"
                >
                  <div className="form-group">
                    <div className="time-slot-task">
                      {/* // Button for Add TimeSlots */}
                      <div className="modal-action-btn text-left">
                        <button
                          type="submit"
                          disabled={isTimeslotBtnDisabled}
                          className="btn btn-primary mb-2"
                          id="book_schedule"
                          onClick={handleAddTimeslotsClick} // Trigger showing TimeslotBookingAdmin
                        >
                          {t(`all-application.Add Timeslots`)}
                        </button>
                      </div>

                      {/* // Conditionally render TimeslotBookingAdmin when showTimeslotBooking is true */}
                      {showTimeslotBooking && (
                        <div>
                          <TimeslotBookingAdmin
                            onValueChange={handleChildValueChange || {}}
                            onErrorHandle={handleErrorsValueChange || {}}
                            defaultTimeSlots={timeSlotsData || {}}
                          />
                          <Form.Group className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-4">
                            <button
                              className="btn btn-secondary"
                              onClick={handleCancelClick} // Hide TimeslotBookingAdmin on click
                            >
                              {t(`all-application.Cancel`)}
                            </button>
                            <ButtonLoader
                              title={t(`all-application.Save Details`)}
                              variant="primary"
                              style={{ marginLeft: "5px" }}
                              type="submit"
                              loading={isLoading}
                              message={"Saving"}
                              onClick={e => {
                                handleTimeslotSubmit(e);
                              }}
                            />
                          </Form.Group>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div
                        id="interview-group"
                        className="form-group form-group-lg col-sm-6 formvisible mb-3"
                      >
                        <label>Interview Title</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={changeHandlers}
                          name="interview_title"
                          id="interview_title"
                          placeholder={t(
                            `all-application.Enter Interview Title`
                          )}
                          value={formData?.interview_title}
                          disabled
                        />
                        {errors?.interview_title && (
                          <p className="text-danger">
                            {errors?.interview_title}
                          </p>
                        )}
                      </div>
                      <div
                        id="interviewer-group"
                        className="form-group form-group-lg col-sm-6 formvisible mb-3"
                      >
                        <label>Interviewer</label>
                        <select
                          id="interviewere_time"
                          onChange={changeHandlers}
                          name="interviewer_time"
                          className="form-select form-control"
                          data-width="100%"
                          data-size="10"
                          title={t(`all-application.Select Interviewer`)}
                          value={formData?.interviewer_time}
                        >
                          <option Selected value="0">
                            {t(`all-application.Select Interviewer`)}
                          </option>
                          {interViewers?.map(el => {
                            return (
                              <option value={el?.value}>{el?.label}</option>
                            );
                          })}
                        </select>
                        {errors?.interviewer_time && (
                          <p className="text-danger">
                            {errors?.interviewer_time}
                          </p>
                        )}
                      </div>
                      <div
                        id="int_schedule_date-group"
                        className="form-group form-group-lg col-sm-6 formvisible date-calender mb-3"
                      >
                        <label>{t(`all-application.Start Date & Time`)}:</label>
                        <DatePicker
                          id="int_start_time"
                          name="int_start_time"
                          selected={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          // onChange={value => {
                          //   if (value >= new Date()) {
                          //     handleStartDateChange(value);
                          //     setErrors({ ...errors, int_start_time: "" });
                          //   } else {
                          //     setErrors({
                          //       ...errors,
                          //       int_start_time: "Cannot Select Past Dates.",
                          //     });
                          //   }
                          // }}
                          onChange={value => handleStartDateChange(value)}
                          selectsStart
                          startDate={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          endDate={int_end_time ? new Date(int_end_time) : ""}
                          minDate={new Date()}
                          placeholderText="dd-mm-yyyy"
                          dateFormat="dd-MMM-yyyy"
                          required={true}
                          className={`form-control`}
                          onKeyDown={e => e.preventDefault()}
                          autoComplete="off"
                          // Remove the time-related props
                          // showTimeSelect
                          // timeFormat="HH:mm"
                          // timeIntervals={30}
                          // includeTimes={availableTimes.map(slot => {
                          //   const [startHour, startMinute] = slot.startTime.split(":");
                          //   const today = new Date();
                          //   const selectedTime = new Date(today.setHours(startHour, startMinute));
                          //   return selectedTime;
                          // })}
                          // timeCaption="Time"
                        />
                        <Form.Control
                          as="select"
                          value={selectedStartTime}
                          onChange={e => handleStartTimeChange(e.target.value)}
                          className="form-control mt-2"
                        >
                          <option value="">
                            {t(`all-application.Select Start Time`)}
                          </option>
                          {sDateTimeSlots?.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </Form.Control>

                        {errors?.selectedStartTime && (
                          <p className="text-danger">
                            {errors?.selectedStartTime}
                          </p>
                        )}
                        <small>{t(`all-application.Max Duration`)}</small>
                        {errors?.int_start_time && (
                          <p className="text-danger">
                            {errors?.int_start_time}
                          </p>
                        )}
                      </div>
                      <div
                        id="int_schedule_date-group"
                        className="form-group form-group-lg col-sm-6 formvisible date-calender mb-3"
                      >
                        <label>{t(`all-application.End Date & Time`)}:</label>
                        <DatePicker
                          id="int_end_time"
                          name="int_end_time"
                          selected={int_end_time ? new Date(int_end_time) : ""}
                          // onChange={value => {
                          //   if (value >= new Date()) {
                          //     handleEndDateChange(value);
                          //     setErrors({ ...errors, int_end_time: "" });
                          //   } else {
                          //     setErrors({
                          //       ...errors,
                          //       int_end_time: "Cannot Select Past Dates.",
                          //     });
                          //   }
                          // }}
                          onChange={value => handleEndDateChange(value)}
                          selectsEnd
                          startDate={
                            int_start_time ? new Date(int_start_time) : ""
                          }
                          endDate={int_end_time ? new Date(int_end_time) : ""}
                          minDate={
                            int_start_time
                              ? new Date(int_start_time)
                              : new Date()
                          }
                          minimumDate={
                            int_start_time ? int_start_time : utils().getToday()
                          }
                          showFullMonthYearPicker
                          // showTimeSelect
                          placeholderText="dd-mm-yyyy"
                          // timeFormat="h:mm aa"
                          required={true}
                          // timeIntervals={15}
                          shouldHighlightWeekends
                          calendarPopperPosition="bottom"
                          autoComplete="off"
                          dateFormat="dd-MMM-yyyy"
                          // timeCaption="Time"
                          className={`form-control`}
                          onKeyDown={e => e.preventDefault()}
                        />
                        <Form.Control
                          as="select"
                          value={selectedEndTime}
                          onChange={handleEndTimeChange}
                          className="form-control mt-2"
                        >
                          <option value="">
                            {t(`all-application.Select End Time`)}
                          </option>
                          {eDateTimeSlots?.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </Form.Control>

                        {errors?.selectedEndTime && (
                          <p className="text-danger">
                            {errors?.selectedEndTime}
                          </p>
                        )}
                        {errors?.int_end_time && (
                          <p className="text-danger">{errors?.int_end_time}</p>
                        )}
                      </div>

                      <Col md={6}>
                        <div
                          id="interviewer-group"
                          className="form-group form-group-lg formvisible mb-3"
                        >
                          <label>
                            {t(`all-application.Select Interview Type`)}:
                          </label>
                          <select
                            id="interviewType"
                            onChange={e => {
                              setFormData(prevFormData => ({
                                ...prevFormData,
                                meeting_type: parseInt(e.target.value),
                              }));
                            }}
                            name="interviewType"
                            className="form-select form-control"
                            data-width="100%"
                            data-size="10"
                            title={t(`all-application.Select Interview Type`)}
                            value={formData?.meeting_type}
                          >
                            <option value={0}>
                              {t(`all-application.Offline`)}
                            </option>
                            <option value={1}>
                              {t(`all-application.Online`)}
                            </option>
                          </select>
                        </div>
                      </Col>
                      {formData?.meeting_type === 1 && teamsIntegrated && (
                        <Col md={6}>
                          <div
                            id="req_documents-group"
                            className="form-group form-group-lg col-sm-12 formvisible mb-3"
                          >
                            <label>
                              {t(`all-application.Schedule on Teams`)}:
                            </label>{" "}
                            <br />
                            <div className="">
                              <label
                                className="switch mt-3"
                                htmlFor={"tableSwitch"}
                              >
                                <input
                                  type="checkbox"
                                  id={`tableSwitch`}
                                  onClick={e => {
                                    setFormData(prevFormData => ({
                                      ...prevFormData,
                                      teams_interview: e.target.checked,
                                    }));
                                  }}
                                  checked={formData?.teams_interview}
                                />
                                <div className="slider round"></div>
                              </label>
                            </div>
                          </div>
                        </Col>
                      )}
                      {formData?.meeting_type === 1 && zoomIntegrated && (
                        <Col md={6}>
                          <div
                            id="req_documents-group"
                            className="form-group form-group-lg col-sm-12 formvisible mb-3"
                          >
                            <label>
                              {t(`all-application.Schedule on Zoom`)}:
                            </label>{" "}
                            <br />
                            <div className="">
                              <label
                                className="switch mt-3"
                                htmlFor={"zoomSwitch"}
                              >
                                <input
                                  type="checkbox"
                                  id={`zoomSwitch`}
                                  onClick={e => {
                                    setFormData(prevFormData => ({
                                      ...prevFormData,
                                      zoom_interview: e.target.checked,
                                    }));
                                  }}
                                  checked={formData?.zoom_interview}
                                />
                                <div className="slider round"></div>
                              </label>
                            </div>
                          </div>
                        </Col>
                      )}

                      <div
                        id="address-group"
                        className="form-group form-group-lg col-sm-6 formvisible mb-3"
                      >
                        {formData?.meeting_type === 0 && (
                          <>
                            <label>
                              {t(`all-application.Enter Offline Address`)}:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={changeHandlers}
                              name="address"
                              id="address"
                              placeholder={t(`all-application.Enter Address`)}
                              value={formData?.address}
                            />
                            {errors?.address && (
                              <p className="text-danger">{errors?.address}</p>
                            )}
                          </>
                        )}
                        {formData?.meeting_type === 1 &&
                          !formData?.teams_interview &&
                          !formData?.zoom_interview && (
                            <>
                              <label>
                                {t(`all-application.Meeting Link`)}:
                              </label>{" "}
                              <br />
                              <input
                                type="text"
                                className="form-control"
                                onChange={changeHandlers}
                                name="address"
                                id="address"
                                placeholder={t(
                                  `all-application.Enter Meeting Link`
                                )}
                                value={formData?.address}
                              />
                              {errors?.address && (
                                <p className="text-danger">{errors?.address}</p>
                              )}
                            </>
                          )}
                      </div>
                      <div
                        id="req_documents-group"
                        className="form-group form-group-lg col-sm-12 formvisible mb-3"
                      >
                        <label>{t(`all-application.Required Docs`)}</label>
                        <textarea
                          type="text"
                          className="form-control"
                          onChange={changeHandlers}
                          name="req_documents"
                          id="req_documents"
                          placeholder={t(
                            `all-application.Mention Documents Needed`
                          )}
                          value={formData?.req_documents}
                        ></textarea>
                        {errors?.req_documents && (
                          <p className="text-danger">{errors?.req_documents}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-action-btn text-left d-flex align-items-center gap-3 mt-4">
                    <button
                      className="btn btn-secondary"
                      onClick={handleToggleForm}
                    >
                      {t(`all-application.Cancel`)}
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      id="book_schedule_submit"
                      disabled={loading} // Disable the button while loading
                    >
                      {loading ? (
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        t(`all-application.Submit`)
                      )}
                    </button>
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
          </div>
        </div>
        {/* NEW MODAL FOR NOTES */}
        {showNotes && (
          <>
            <div className="edit-modal">
              <Modal
                show={showNotes}
                onHide={handleCloseModal}
                className="edit-modal-card interview_Notes"
              >
                {/* <Modal.Header closeButton></Modal.Header> */}
                <Modal.Body>
                  <div className="filters-cards-cross">
                    <div className="filter-content">
                      <h4>Interview Notes</h4>
                    </div>
                    <div
                      className="filter-content cross"
                      onClick={() => {
                        handleCloseModal();
                        setAssessmentModal(true);
                      }}
                    >
                      <img src={cross} alt="" />
                    </div>
                  </div>
                  <div className="bordertops"></div>
                  <div className="interview-notes-cards">
                    <div className="row">
                      {allNotes?.length > 0 &&
                        allNotes?.map(el => {
                          return (
                            <Col lg={12} className="mb-2">
                              <div className="chat-nots-card">
                                <div className="chat-header">
                                  <div>
                                    <h6>{el?.user?.name || ""} </h6>
                                    <p>({el?.user?.email || ""}) </p>
                                  </div>
                                  <div
                                    className="delete-icon cursor-pointer"
                                    title={t(`View Details.Remove Note`)}
                                    onClick={() => handleRemoveNote(el)}
                                  >
                                    <span>
                                      <img
                                        src={delete_icon}
                                        alt="delete icon"
                                      />
                                    </span>
                                  </div>
                                </div>
                                <div className="chat-comment">
                                  <p>
                                    {readMoreStates[el.id]
                                      ? el?.note
                                      : `${el?.note.substring(0, 250)}`}

                                    {el?.note.length > 250 && (
                                      <button
                                        onClick={() => toggleReadMore(el.id)}
                                        className="btn btn-link"
                                      >
                                        {readMoreStates[el.id]
                                          ? t(`View Details.Read Less`)
                                          : t(`View Details.Read More`)}
                                      </button>
                                    )}
                                  </p>
                                </div>

                                <div className="chat-footer">
                                  <div className="chat-calender">
                                    {/* <span>
                                    <img src={calednder} alt="" />
                                  </span> */}
                                    <p>
                                      {el?.createdAt
                                        ? moment(
                                            getCompanyTimezoneDateTime(
                                              el?.createdAt
                                            )
                                          ).format("Do MMM'YY | hh:mm a")
                                        : ""}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      {allNotes?.length === 0 && (
                        <>
                          <div className="no-data data-available">
                            <img
                              src="../../img/data-not-available.png"
                              alt="data not available"
                            />
                            <h3>{t(`View Details.No Item Found`)}</h3>
                            <p>
                              {t(`View Details.Sorry, we could not find any`)}
                              <br />
                              {t(`View Details.Item to show here`)}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default PendingList;
